import {Avatar, Button, Card, CardContent, Grid, IconButton, Tooltip, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ReviewsIcon from "@mui/icons-material/Reviews";
import CloseIcon from "@mui/icons-material/Close";
import FavoriteIcon from "@mui/icons-material/Favorite";
import BoltIcon from "@mui/icons-material/Bolt";


export default function UserCard({ user, showRemoveButton, onUnfollow }) {
    return(
        <Card sx={{position: 'relative', backgroundColor:"#a4c3b2ff", marginTop:"1vw", alignItems:"center", justifyContent:"center", borderRadius: '3%'}}>
            {
                showRemoveButton &&
                <Tooltip title={`Rimuovi ${user.username} dai seguiti`}>
                    <IconButton sx={{ position: "absolute", top: 0, right: 0,
                        "&:hover": { backgroundColor: "red" } }}
                                onClick={ () => onUnfollow(user._id, user.username) }>
                        <CloseIcon sx={{ color: 'black' }}/>
                    </IconButton>
                </Tooltip>
            }
            <CardContent>
                <Grid container spacing={2}>
                    <Grid size={2}>
                        <Button component={Link} to={`/${user.username}/profile`}>
                            <Avatar sx={{ display:"flex", justifyContent:"center" }} />
                        </Button>
                    </Grid>
                    <Grid size={3}>
                        <Typography component="p">
                        <Link className="link_card" to={`/${user.username}/profile`}>
                            {user.username}</Link>
                        </Typography>
                        <Button sx={{color:"#344e41"}} component={Link} to={`/${user.username}/followers`} disabled={user.followers.length === 0}>
                            {user.followers.length} Followers
                        </Button>
                        <Button  sx={{color:"#344e41"}} component={Link} to={`/${user.username}/following`} disabled={user.following.length === 0}>
                            {user.following.length} Following
                        </Button>
                    </Grid>

                    <Grid size={5} sx={{ display:"flex", justifyContent:"center"}}>
                        <Tooltip title={`Watchlist di ${user.username}`}>
                            <IconButton component={Link} to={`/${user.username}/watchlist`}>
                                <WatchLaterIcon sx={{color:"#344e41"}}/>
                            </IconButton>
                        </Tooltip>

                        <Tooltip title={`Film visti da ${user.username}`}>
                            <IconButton component={Link} to={`/${user.username}/watched`}>
                                <VisibilityIcon sx={{color:"#344e41"}} />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title={`Recensioni di ${user.username}`}>
                            <IconButton component={Link} to={`/${user.username}/reviews`}>
                                <ReviewsIcon sx={{color:"#344e41"}} />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title={`Film preferiti di ${user.username}`}>
                            <IconButton component={Link} to={`/${user.username}/favorites`}>
                                <FavoriteIcon sx={{color:"#344e41"}} />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title={`Attività di ${user.username}`}>
                            <IconButton component={Link} to={`/${user.username}/activity`}>
                                <BoltIcon sx={{color:"#344e41"}} />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}
